(function () {
  // function isMobile() {
  //   const ua = navigator.userAgent.toLowerCase();
  //   return /iphone|ipad|ipod|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian/.test(ua);
  // }
  const modleDiv = document.querySelector(
    "#section-template--24563292209465__media_with_text_overlay_NEDxYR"
  );
  if (modleDiv) {
    const currentDiv = modleDiv.querySelector("div");
    if (currentDiv) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              currentDiv.classList.add("active");
              console.log("Div 首次进入视口 50%！");
              observer.unobserve(entry.target); // 只触发一次后取消监听（可选）
            }
          });
        },
        (options = {
          root: null, // 默认是视口（viewport）
          rootMargin: "0px", // 视口边缘的额外检测区域
          threshold: 0.5, // 当 50% 元素可见时触发
        })
      );
      observer.observe(currentDiv);
      // if (isMobile()) {
      //   // currentDiv.classList.add('active')
      // } else {
      //   observer.observe(currentDiv);
      // }
    }
  }
})();
